import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import BackButton from '../components/BackButton';
import Icon from '../components/Icon';
import './styles/VocabularyScreen.css';

const VocabularyScreen = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const items = [
    { finnish: 'Opi sanastoa',      label: t('learnVocabulary'),  icon: 'book',   color: 'var(--color-vocab)',    bgColor: 'var(--color-vocab-dim)',    path: '/book-screen' },
    { finnish: 'Testi sanasto',     label: t('testVocabulary'),   icon: 'target', color: 'var(--color-error)',    bgColor: 'var(--color-error-dim)',    path: '/test-setting-screen' },
    { finnish: 'Kuuntele sanastoa', label: t('listenVocabulary'), icon: 'headphones', color: 'var(--color-writing)', bgColor: 'var(--color-writing-dim)', path: '/play-setting-screen' },
    { finnish: 'Kirjoita sanastoa', label: t('writeVocabulary'),  icon: 'pen',    color: 'var(--color-success)',  bgColor: 'var(--color-success-dim)',  path: '/write-vocabulary-settings' },
  ];

  return (
    <div className="container">
      <BackButton to="/" label={t('home')} />
      <h2 className="page-title">{t('vocabulary')}</h2>
      <div className="section-cards">
        {items.map((item, index) => (
          <button className="section-card" key={index} onClick={() => navigate(item.path)}>
            <div className="section-icon-container" style={{ backgroundColor: item.bgColor }}>
              <span className="section-icon" style={{ color: item.color }}><Icon name={item.icon} size={24} /></span>
            </div>
            <div className="section-card-text">
              <span className="section-card-title" style={{ color: item.color }}>{item.finnish}</span>
              <span className="section-card-subtitle">({item.label})</span>
            </div>
            <span className="section-card-arrow">&rsaquo;</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default VocabularyScreen;
